<template>
  <div class='our-products-section-wrapper'>
      <div class='second-background'>
        <div class="login-wrapper">
          <div class="login-header text-center">
            <h3 class='h3-title'>Войти в аккаунт</h3>
          </div>
          <div class='login-from-wrapper'>
            <form validate v-on:submit.prevent="submitForm">
              <div class='login-form-item'>
                <div class='paragraph'>
                  Email:
                </div>
                <div>
                  <input type="email" class='app-input app-input-asset app-input-middle' minlength="6" maxlength="32" v-model="email" autocomplete="on">
                </div>
              </div>
              <div class='login-form-item'>
                <div class='paragraph'>
                  Пароль:
                </div>
                <div>
                  <input type="password" class='app-input app-input-asset app-input-middle' minlength="6" maxlength="32" v-model="password" autocomplete="off">
                </div>
              </div>
              <!-- <div class='login-form-item'>
                <div class="g-recaptcha" data-sitekey="6Lc0d5EUAAAAAKSfDKUFlFn8LjuJOG9-CQOfOjOL"></div>
              </div> -->
              <div class='submit-button'>
                <div class='text-error'>
                  {{error}}
                </div>
                <button class="app-btn app-btn-primary">
                  Отправить
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import router from '@/router.js'
export default {
  data () {
    return {
      email: null,
      password: null,
      error: null
    }
  },
  name: 'Login',
  computed: {},
  components: {},
  methods: {
    ...mapActions([
      'loginUser'
    ]),
    ...mapMutations([
      'tokenWasChanged'
    ]),
    submitForm () {
      const prepareData = {
        email: this.email,
        password: this.password
      }
      this.loginUser(prepareData).then(
        (data) => {
          console.log(data)
          this.error = null
          localStorage.setItem('auth_token', data.jwt)
          router.push('products')
          this.tokenWasChanged(true)
        },
        (error) => {
          this.error = error
          console.log(error)
        }
      )
    }
  },
  mounted () {}
}
</script>

<style lang="scss" scoped>
@import 'src/styles/_colors.scss';
@import 'src/styles/_sizes.scss';

.our-products-section-wrapper {
  background:  #ffffff url("/assets/backgrounds/main-bg.jpg");
  background-size: cover;
  min-height:  calc(100vh - 60px);
  width: 100%;
  position: relative;
  .second-background {
    display: flex;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: $half-black-color;
    align-items: center;
    justify-content: center;
    .login-wrapper {
      width: 360px;
      min-width: 278px;
      margin: 10px;
      padding: 10px;
      background: $white-color;
      border-radius: 10px;
      border: 1px solid $primary-color;
      box-shadow: 0px 0px 5px $primary-color;
      .login-header {
        border-bottom: 1px solid $border-color;
        padding-bottom: 10px;
      }
      .login-from-wrapper {
        padding-top: 10px;
        .login-form-item {
          display: flex;
          flex-direction: column;
          margin-bottom: 10px;
          div:first-child {
            margin-bottom: 5px;
            display: flex;
          }
          div:last-child {
            display: flex;
          }
        }
        .submit-button {
          padding-top: 5px;
          display: flex;
          justify-content: space-between;
          .text-error {
            font-size: 12px;
          }
        }
      }
    }
  }
}
</style>
